import { App } from './app-model';

export class AppListResponse {
    status:String;
    errorCode:number;
    errorMessage:string;
    appListView:App[];  

}
